<template>
    <b-field
        :label="label"
        :message="validationMessage"
        :type="validationType"
        :key="updateKey"
    >
        <span v-if="mode == 'edit'">
            <b-input v-model="internalValue" :placeholder="placeholder" :disabled="disabled"></b-input>
        </span>
        <span v-else-if="mode == 'view'" class="underlined">{{ value }}</span>
    </b-field>
</template>

<script>
export default {
    name: 'IBANinput',

    props: {
        value: {
            type: String
        },
        label: {
            type: String,
            required: false,
            default: 'Bankrekeningnummer (IBAN)'
        },
        placeholder: {
            type: String,
            required: false,
            default: 'NL00BANK1234567890'
        },
        mode: {
            type: String,
            required: false,
            default: 'edit'
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: ''
        },
        errorType: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            updateKey: 0,
            internalValue: this.value || ''
        }
    },

    computed: {
        validationMessage() {
            // Show prop error message if provided, otherwise show IBAN validation
            if (this.errorMessage) {
                return this.errorMessage
            }
            if (this.internalValue && this.internalValue.trim().length > 0) {
                if (this.isValidIBAN(this.internalValue)) {
                    return 'Het IBAN-formaat is correct.'
                } else {
                    return 'Vermoedelijk is dit een foutief IBAN nummer, controleer dit.'
                }
            }
            return ''
        },
        validationType() {
            // Show prop error type if provided, otherwise show validation feedback
            if (this.errorType) {
                return this.errorType
            }
            if (this.internalValue && this.internalValue.trim().length > 0) {
                if (this.isValidIBAN(this.internalValue)) {
                    return 'is-success'
                } else {
                    return 'is-info'
                }
            }
            return ''
        }
    },

    methods: {
        isValidIBAN(iban) {
            if (!iban) return true // Empty is valid (not required)

            // Remove spaces and convert to uppercase
            const cleaned = iban.replace(/\s/g, '').toUpperCase()

            // Basic format check: 2 letters (country) + 2 digits (check) + alphanumeric
            if (!/^[A-Z]{2}[0-9]{2}[A-Z0-9]+$/.test(cleaned)) {
                return false
            }

            // Length check: IBAN must be between 15 and 34 characters
            if (cleaned.length < 15 || cleaned.length > 34) {
                return false
            }

            // Modulo 97 check (standard IBAN validation algorithm)
            // Move first 4 characters to end and convert letters to numbers
            const rearranged = cleaned.slice(4) + cleaned.slice(0, 4)
            const numeric = rearranged.replace(/[A-Z]/g, (char) => {
                return (char.charCodeAt(0) - 55).toString()
            })

            // Calculate modulo 97: process digit by digit
            // Multiply remainder by 10, add next digit, take modulo 97
            let remainder = 0
            for (let i = 0; i < numeric.length; i++) {
                remainder = (remainder * 10 + parseInt(numeric[i])) % 97
            }

            return remainder === 1
        }
    },

    watch: {
        value: {
            handler(newValue) {
                // Always update internalValue when value prop changes
                if (newValue !== this.internalValue) {
                    this.internalValue = newValue || ''
                    this.updateKey++
                }
            },
            immediate: true
        },

        internalValue(newValue) {
            // Emit update event whenever internalValue changes
            if (newValue !== this.value) {
                this.$emit('update', newValue)
            }
        }
    }
}
</script>
